import { IUser } from 'app/shared/model/user.model';
import { IEcole } from './ecole.model';
export interface IComptable {
  id?: string;
  ecole?: IEcole | null;
  firstName?: string;
  lastName?: string;
  telephone?: number;
  adresse?: string;
  authorities?: any[];
  login?: string;
  email?: string;
  activated?: boolean;
  ecoleId?: string;
  user?: IUser | null;
}

export const defaultValue: Readonly<IComptable> = {
  id: null,
  ecole: null,
  firstName: '',
  lastName: '',
  telephone: null,
  adresse: '',
  authorities: [],
  login: '',
  email: '',
  activated: true,
  ecoleId: '',
  user: null,
};
